import * as angular from "angular";
import {IController} from "angular";
import {PriceType} from "../../types/price.type";

export class QuantitySettingsTableCtrl implements IController {

  priceType: PriceType;
  quantitySettings: any;
  onAmountChange: Function;
  onChange: Function;
  onRemove: Function;

  /* @ngInject */
  constructor() {}

  $onInit() {

  }


}
angular
  .module('bringoz.admin.pricePlan')
  .component('quantitySettingsTable', {
    require : {
      form : '^form'
    },
    bindings: {
      priceType: '<',
      quantitySettings: '<',
      onAmountChange: '&',
      onChange: '&',
      onRemove: '&'
    },
    template: require('./quantity-settings-table.html').default,
    controller: QuantitySettingsTableCtrl
  });
